import { MessageAutomationConfiguration } from 'src/models/MessageAutomationConfiguration';

export default class SmsConfiguration {
  id: string;
  name?: string;
  number: string;
  messageAutomationConfiguration?: MessageAutomationConfiguration;
}
